<template>
<div id="contentWrap">
    <div class="content right">
        <div id="content_1block" class="right">
            <div class="response">
                <div class="resendmail linkfont"><span style="color: #009A21;">یک لینک جهت ریست و بازیابی رمز عبور شما برایتان ارسال گردید. <a href="javascript: void(0)">{{email}}</a></span>
                    <p>درصورت عدم دریافت ایمیل، لطفا کلیک کنید روی <a href="javascript: void(0)" @click="ResendMail()">اینجا</a> تا ایمیل دوباره ارسال گردد.</p>
                </div>
            </div>
            <div style="width: 200px; margin-right: auto; margin: auto;">
                <button class="button-warning pure-button button-download" @click="back()">بازگشت به صفحه اصلی</button>
            </div>
        </div>
        <modal v-if="showModal" @close="showModal = false" />
    </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import router from '../../router.js';
import Modal from '../../tools/Modal';
export default {
    components: {
        Modal
    },
    data: function() {
        return {
            email: '',
            showModal: false
        };
    },
    methods: {
        ResendMail: function() {
            var url = sessionStorage.getItem('forgetpswLink');
            this.showModal = true;
            this.$http.get(url).then((response) => {
                // success callback
                var datums = response.data;
                if (datums > 0) {
                    this.showModal = false;
                } else {

                }
            }, (response) => {
                // error callback
            });
        },
        back: function() {
            router.push('/');
        }
    },
    mounted() {
        this.email = sessionStorage.getItem('forgetpswEmail');
    }
};
</script>
<style scoped>
.button-download {
    width: 200px;
    background: rgb(255, 90, 0);
    /* this is a green */
    color: #FFFFFF;
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// ResendMail.vue?26dbdfeb